import dataLoader from '@/scripts/dataLoader';

const state = {
    allLoaded: false,
    stateYearCounts: null,
    variableDataLists: null,
    allYears: null,
    allLocations: null
}

// gettersdata
const getters = {
    allAreLoaded: (state, getters) => {
        return state.allLoaded;
    },
}

function sortBoth(v1, v2, k) {
    v1.sort((a, b) => a[k] - b[k]);
    v2.sort((a, b) => a[k] - b[k]);
}

function compareKeys(a, b, keys) {
    var results = 0;

    for (var i = 0; i < keys.length && results === 0; ++i) {
        var k = keys[i];
        if (a[k] < b[k])
            results = 1;
        else if (a[k] > b[k])
            results = 1;
    }
    return results;
}

function getKeyValues(r, keys) {
    return keys.map(k => r[k]).join(',');
}

function compare(g1, g2, name, keys) {
    var v1 = g1[name];
    var v2 = g2[name];
    var key = keys[0];
    var reversedKeys = keys.map(k => k);
    reversedKeys.reverse();
    
    reversedKeys.forEach(k => sortBoth(v1, v2, k));
    
    
    
    for (var i1 = 0, i2 = 0;
        i1 < v1.length - 1 && i2 < v2.length - 1; 
        ++i1, ++i2 
    )
    {
        var a = v1[i1];
        var b = v2[i2];
        
        var keysCompare = compareKeys(a, b, keys);
        var akeys = getKeyValues(a, keys);
        var bkeys = getKeyValues(b, keys);
        
        if (keysCompare > 0) {
            console.log(`missing ${name} row: ${getKeyValues(a, keys)}`);
            a--;

        }
        else if (keysCompare < 0) {
            console.log(`Add ${name} row: ${getKeyValues(b, keys)}`);
            b--;
        }
        else compareObject(name, a, b);
    }
    console.log('ended', i1, i2, v1.length, v2.length)
}

function compareObject(name, a, b) {

}

// actions
const actions = {
    //import store from '@/store';
    // const stateYearCounts = store.state.dataLists.stateYearCounts;
    // const allYears = store.state.dataLists.allYears;
    // const allLocations = store.state.dataLists.allLocations;
    // const variableDataLists = store.state.dataLists.variableDataLists;

    //Delete Promise.then( variablesPromise
    //Delete data/
    load({ commit, state }) {
        dataLoader.loadWithPromise('datalists_stateYearCounts').then((stateYearCounts) => {
            commit('loaded', { name: 'stateYearCounts', dataList: stateYearCounts });
        });
        dataLoader.loadWithPromise('datalists_variables').then((variableDataLists) => {
            commit('loaded', { name: 'variableDataLists', dataList: variableDataLists });
            
            // var v = variableDataLists;

            // dataLoader.loadWithPromise('datalists_variables2021').then((v2021) => {

            //     //levelCounts have multiple duplicates

            //     // compare(v, v2021, 'groups', ['groupId']);
            //     compare(v, v2021, 'levelCounts', ['variable']);
            //     // compare(v, v2021, 'levels', ['var', 'id']);
            //     compare(v, v2021, 'variables', ['variable']);
            //     compare(v, v2021, 'variableYears', ['variable', 'surveyYear']);
                
            // });


        });
        dataLoader.loadWithPromise('datalists_years').then((allYears) => {
            commit('loaded', { name: 'allYears', dataList: allYears });
        });
        dataLoader.loadWithPromise('datalists_states').then((allLocations) => {
            commit('loaded', { name: 'allLocations', dataList: allLocations });
        });
    }
}

// mutations
const mutations = {
    loaded(state, { name, dataList }) {
        state[name] = dataList;
        if (state.stateYearCounts && state.variableDataLists && state.allYears && state.allLocations)
            state.allLoaded = true;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
